import { RouteSuggestionMapper } from '@/javascript/infra/mappers/route-suggestion-mapper'

export const makeRouteSuggestionMapper = (): RouteSuggestionMapper => {
  return new RouteSuggestionMapper()
}
